import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Wizard from './Wizard';
import Page1 from './checkin/Page1';
import Page2 from './checkin/Page2';
import Page3 from './checkin/Page3';

const getWizardConfig = _translations => {
  return {
    sender: 'checkin',
    page1: {
      btn_next: {
        text: _translations.next,
      },
      btn_prev: {
        text: _translations.previous,
      },
    },
    page2: {
      btn_next: {
        text: _translations.accept,
      },
      btn_prev: {
        text: _translations.previous,
      },
    },
    page3: {
      btn_next: {
        text: _translations.finish,
      },
      btn_prev: null,
    },
  };
};

const emptyState = {
  firstName: '',
  lastName: '',
  companyName: '',
  phoneNumber: '',
  expectedVisitDuration: 0,
  errors: [],
  matches: [],
  agree: false,
};

const validationRules = {
  page1: {
    firstName: ['required'],
    lastName: ['required'],
    companyName: ['required'],
    phoneNumber: ['required|phone_number'],
    heroFirstName: ['required'],
    heroLastName: ['required'],
  },
  page2: {
    agree: ['checked'],
  },
};

/**
 * Parse the state to an allowed format by the API
 * @param {object} data
 * @returns object
 */
const parseSubmit = data => {
  return {
    firstName: data.firstName,
    lastName: data.lastName,
    companyName: data.companyName,
    phoneNumber: data.phoneNumber,
    expectedVisitDuration: data.expectedVisitDuration + 1,
    matches: data.matches,
    officeId: window.__env.visitorAccessOfficeId,
  };
};

const parseWantedHero = data => {
  return {
    heroFirstName: data.heroFirstName,
    heroLastName: data.heroLastName,
    officeId: window.__env.visitorAccessOfficeId,
    visitorPhoneNumber: data.phoneNumber,
  };
};
export default class VisitorCheckinForm extends Component {
  constructor(props) {
    super(props);

    // Default state
    this.state = emptyState;
  }

  /**
   * Store the updates in state
   * @param {object} data
   */
  saveInState(data) {
    this.setState(data);
  }

  render() {
    const { firstName, lastName, companyName, phoneNumber, expectedVisitDuration, agree, errors, heroFirstName, heroLastName } = this.state;
    const { translations, checkinVisitor, isLoading, setGoTo, goTo, allowCheckin, matches } = this.props;

    const wizardConfig = getWizardConfig(translations);
    _.set(wizardConfig, 'page2.btn_next.action', data => checkinVisitor(data));
    _.set(wizardConfig, 'page1.btn_next.action', data => allowCheckin(data));

    return (
      // eslint-disable-next-line no-shadow
      <Wizard
        config={wizardConfig}
        parentState={this.state}
        saveErrorsInState={_errors => this.saveInState(_errors)}
        submitData={parseSubmit(this.state)}
        lastPageRedirect="/visitor"
        lastPageAutomaticRedirectAfter="10"
        isLoading={isLoading}
        goTo={goTo}
        setGoTo={setGoTo}
        translations={translations}
        wantedHero={parseWantedHero(this.state)}
      >
        <Page1
          setFieldValue={data => this.saveInState(data)}
          firstName={firstName}
          lastName={lastName}
          companyName={companyName}
          phoneNumber={phoneNumber}
          expectedVisitDuration={expectedVisitDuration}
          errors={errors}
          validationRules={validationRules.page1}
          validationMessages={_.get(translations, 'validationMessages', {})}
          translations={translations}
          setGoTo={setGoTo}
          config={wizardConfig}
          heroFirstName={heroFirstName}
          heroLastName={heroLastName}
        />
        <Page2
          setFieldValue={data => this.saveInState(data)}
          agree={agree}
          errors={errors}
          validationRules={validationRules.page2}
          validationMessages={_.get(translations, 'validationMessages', {})}
          translations={translations}
          setGoTo={setGoTo}
          config={wizardConfig}
          matches={matches}
        />
        <Page3
          firstName={firstName}
          lastName={lastName}
          translations={translations}
          lastPageRedirect="/visitor"
          setGoTo={setGoTo}
          config={wizardConfig}
          heroFirstName={heroFirstName}
        />
      </Wizard>
    );
  }
}

VisitorCheckinForm.propTypes = {
  translations: PropTypes.shape(),
  checkinVisitor: PropTypes.func.isRequired,
  allowCheckin: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  goTo: PropTypes.string,
  setGoTo: PropTypes.func.isRequired,
  matches: PropTypes.arrayOf(PropTypes.shape),
};
VisitorCheckinForm.defaultProps = {
  translations: {},
  isLoading: false,
  goTo: null,
  matches: [],
};
